import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';

export class FilerFileEntity extends Entity {
  static idField = 'id';

  static fields: EntityFields<FilerFileEntityFields> = {
    id: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
    url: new Fields.CharField({ blank: true, local: true }),
  };
}

export type FilerFileEntityFields = {
  id: string;
  name: string;
  url: string;
};

export type FilerFileEntityRecord = EntityRecord<FilerFileEntityFields>;

export class FilerImageEntity extends Entity {
  static idField = 'id';

  static fields: EntityFields<FilerImageEntityFields> = {
    id: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
    url: new Fields.CharField({ blank: true, local: true }),
    thumbnails: new Fields.AnyField({ blank: true, local: true }),
  };
}

export type FilerImageEntityFields = {
  id: string;
  name: string;
  url: string;
  thumbnails: unknown;
};

export type FilerImageEntityRecord = EntityRecord<FilerImageEntityFields>;
